<script lang="ts">
  import DMLogo from 'Catalyst/components/NavBrand/Logotype.svelte';

  export let whitelabelingSettingsPresent: boolean;
  export let logoUrl: string;
  export let companyName: string;
</script>

{#if whitelabelingSettingsPresent}
  {#if logoUrl}
    <img
      src={logoUrl}
      class="max-w-[20rem] max-h-[2.5rem]"
      data-testid="whitelabeling-logo"
      alt={`${companyName || 'logo'}`}
    />
  {/if}
{:else}
  <DMLogo class="w-[11.125rem] h-auto" />
{/if}
